import { Component, computed, inject, model, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StatusGroup } from '@app/_api/dto';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { MultiSelectStatusGroupComponent } from '@app/shared/multi-select-status-group/multi-select-status-group.component';

export type VisibilityChoice = 'AllVisible' | 'NoneVisible' | 'SpecificGroups';

@Component({
  selector: 'if-visibility-settings',
  templateUrl: './visibility-settings.component.html',
  styles: `
    @reference '../../../styles.css';

    fieldset > label {
      @apply label w-full p-4 has-checked:bg-primary/40 hover:bg-base-300;
      & > input[type='radio'] {
        @apply self-start mt-1;
        & + div {
          @apply whitespace-normal space-y-1 gap-2;
          & > small {
            @apply text-xs text-base-content/70;
          }
        }
      }
    }
  `,
  imports: [MultiSelectStatusGroupComponent, FormsModule],
})
export class VisibilitySettingsComponent implements OnInit {
  readonly selectedVisibilityGroups = model<StatusGroup[]>();

  protected readonly visibilityChoice = signal<VisibilityChoice | undefined>(undefined);
  protected readonly allStatusGroups = computed(() => this.employeeDataService.allStatusGroups() ?? []);
  private readonly employeeDataService = inject(EmployeeDataService);

  ngOnInit() {
    const initialSelectedGroups = this.selectedVisibilityGroups();
    if (!initialSelectedGroups) return;
    if (initialSelectedGroups.length === 0) {
      this.visibilityChoice.set('NoneVisible');
    } else if (initialSelectedGroups.length === this.allStatusGroups().length) {
      this.visibilityChoice.set('AllVisible');
    } else {
      this.visibilityChoice.set('SpecificGroups');
    }
  }

  protected clearSelection() {
    this.selectedVisibilityGroups.set([]);
  }

  protected selectAll() {
    this.selectedVisibilityGroups.set([...this.allStatusGroups()]);
  }
}
